import { DASHBOARD_MENU_KEY } from "@components/Sidebar/config/menu.keys";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ConfigState {
	selectedMenuItem: string;
}

const initialState: ConfigState = {
	selectedMenuItem: DASHBOARD_MENU_KEY,
};

const configSlice = createSlice({
	name: "config",
	initialState,
	reducers: {
		setSelectedMenuItem(state, action: PayloadAction<string>) {
			state.selectedMenuItem = action.payload;
		},
	},
});

export const { setSelectedMenuItem } = configSlice.actions;
export default configSlice.reducer;
